import React from "react";
import {
    FaHome,
    FaFileUpload,
    FaChartLine,
    FaEnvelope,
    FaCommentDots,
    FaTicketAlt,
    FaUserClock,
    FaExchangeAlt,
    FaCreditCard,
    FaSearch,
    FaUsers
} from "react-icons/fa";

const AdminSidebar = ({
    activeTab,
    setActiveTab,
    isSidebarOpen,
    setSidebarOpen,
    profile,
}) => {
    // Define menu items with their logic
    const menuItems = [
        {
            id: "home",
            label: "Home",
            icon: <FaHome />,
            show: true,
        },
        {
            id: "bulk",
            label: "Bulk Registration",
            icon: <FaFileUpload />,
            show: profile !== "view_access",
        },
        {
            id: "graphs",
            label: "Analytics",
            icon: <FaChartLine />,
            show: true,
        },
        {
            id: "email",
            label: "Email Editor",
            icon: <FaEnvelope />,
            show: profile !== "view_access",
        },
        {
            id: "feedback",
            label: "Feedbacks",
            icon: <FaCommentDots />,
            show: true,
        },
        {
            id: "dispute",
            label: "Support Tickets",
            icon: <FaTicketAlt />,
            show: true,
        },
        {
            id: "unverifiedUsers",
            label: "Unverified Users",
            icon: <FaUserClock />,
            show: true,
        },
        // Uncomment if needed, based on original file comments
        // {
        //   id: "search",
        //   label: "Search User",
        //   icon: <FaSearch />,
        //   show: true,
        // },
        // {
        //   id: "users",
        //   label: "Users",
        //   icon: <FaUsers />,
        //   show: true,
        // },
        {
            id: "recentTransactions",
            label: "Transactions",
            icon: <FaExchangeAlt />,
            show: true,
        },
        {
            id: "subscription",
            label: "Subscriptions",
            icon: <FaCreditCard />,
            show: true,
        },
    ];

    return (
        <nav className={`side-bar ${isSidebarOpen ? "show" : ""}`}>
            {menuItems.map((item) => {
                if (!item.show) return null;
                return (
                    <button
                        key={item.id}
                        className={`nav-link ${activeTab === item.id ? "active" : ""}`}
                        onClick={() => {
                            setActiveTab(item.id);
                            setSidebarOpen(false);
                        }}
                        style={{ display: "flex", alignItems: "center", gap: "10px" }}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </button>
                );
            })}
        </nav>
    );
};

export default AdminSidebar;
